"use strict";

var LoggerInstance = require("js-logger").get("EmailSubscriptionStore");

var AbstractStore = require("./AbstractStore");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var state = {
	isDesignMode: false,
	wizardEmailSubscriptionDisplayMessages: {}
};

var EmailSubscriptionStore = class extends AbstractStore {
	constructor(dispatcher) {
		super();
		this.dispatchToken = dispatcher.register(action => {
			switch (action.actionType) {
				case Constants.EMAIL_SUBSCRIPTION_INITIALIZE:
					state.isDesignMode = action.isDesignMode;
					state.wizardEmailSubscriptionDisplayMessages = action.wizardEmailSubscriptionDisplayMessages;
					return true; // Don't emit change

				default:
					// no op
					return true;
			}

			this.emitChange();
			return true;
		});
	}

	getState() {
		return state;
	}

	get(key) {
		return state[key];
	}
};

module.exports = new EmailSubscriptionStore(Dispatcher);
